import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {CartInterface} from '../../services/cart/cart.interface';
import {MatFormField} from "@angular/material/form-field";
import {debounceTime, Subject, Subscription} from "rxjs";
import {cloneDeep} from "lodash-es";

@Component({
  selector: 'app-add-remove',
  templateUrl: './add-remove.component.html',
  styleUrls: ['./add-remove.component.scss']
})
export class AddRemoveComponent implements OnInit, OnDestroy {
  @ViewChild('inputElement')
  public inputElement: MatFormField;
  public userAction: boolean;

  private _count: number;
  private _prevCount: number;
  @Input()
  set count(value: number) {
    this._count = value;
    this.countChange.emit(this._count);
    setTimeout(() => {
      if (this.userAction) {
        this._inputDebounce.next(value);
        if (this.autoBind) {
          this.inputElement._control.ngControl.control.markAsPristine();
        }
        this.userAction = false;
      }
    }, 0);
  }
  get count(): number {
    return this._count;
  }
  @Input()
  max: number;
  @Input()
  alignRight: boolean;
  @Input()
  autoBind: boolean;
  @Input()
  withHints: boolean;

  @Output()
  remove: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  add: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  countChange: EventEmitter<number> = new EventEmitter<number>();

  public applying: boolean;
  private _debounceSub: Subscription;
  private _inputDebounce: Subject<number> = new Subject<number>();

  public ngOnInit(): void {
    this._prevCount = cloneDeep(this.count);
    this._debounceSub = this._inputDebounce.pipe(debounceTime(500)).subscribe(value => {
      this.validateValue();
    });
  }
  public ngOnDestroy(): void {
    if (this._debounceSub) {
      this._debounceSub.unsubscribe();
      delete this._debounceSub;
    }
  }

  public addCount(): void {
    if (this.autoBind) {
      this._count++;
      this.countChange.emit(this._count);
      this.applying = true;
    }
    this.add.emit();
  }
  public removeCount(): void {
    if (this.autoBind) {
      this._count--;
      this.countChange.emit(this._count);
      this.applying = true;
    }
    this.remove.emit();
  }
  public validateValue(): void {
    if (this.autoBind) {
      if (this.count > this._prevCount + this.max) {
        this.count = this._prevCount + this.max;
      }
    }
  }

}
